import webviewCall from '@/utils/webviewCall'
import { getUrlQuery } from '@/utils/url'

const getNotify = async (key) => {
  return await window.webview.callHandler(key)
}

const callWebview = async (eventName, args) => {
  console.log('__callWebview__', eventName, window.webview.callHandler)
  // window.webview.callHandler(eventName, ...args)
  // window.webview.callHandler('request', userApi.infoUrl)
  window.webview.callHandler(eventName, args)
}
const init = () => {
  return new Promise((resolve, reject) => {
    const urlQuery = getUrlQuery()
    if (window.flutter_inappwebview) {
      window.webview = window.flutter_inappwebview

      window.isWebview = Boolean(window.flutter_inappwebview)
      window.addEventListener("flutterInAppWebViewPlatformReady", function (event) {
        console.log('flutterInAppWebViewPlatformReady', event)
        resolve()
      })
    } else {
      resolve()
    }
  })
}



export default {
  init,
  getNotify,
  callWebview
}